import {useCallback, useEffect, useState} from "react";
import {css} from "@panda/css";

import {OpenStreetMapsWithPoi} from "../../../maps/components/map_with_poi/OpenStreetMapsWithPoi";
import {POI_DISTANCE_DEFAULT_VALUE} from "../../../maps/constants/pois_defaults";
import {useMapNearbyOffersPois} from "../../../maps/hooks/use_map_nearby_offers_pois";
import {useSinglePoiMarker} from "../../../maps/hooks/use_single_poi_marker";
import {clearPendingSinglePoi} from "../../../maps/state/pending_single_poi_slice";
import {trackAmplitudeMapPoiClick} from "../../../maps/tracking/track_amplitude_poi_click";
import {PolygonType} from "../../../maps/types/PolygonType";
import {OsmPoiClickHandler} from "../../../maps/utils/create_get_osm_poi_marker";
import {getHasCountryPois} from "../../../maps/utils/get_has_country_pois";
import {IPropertyDetailOffer} from "../../../property/types/IPropertyDetailOffer";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {ViewType} from "../../../view_type/ViewType";
import {IOfferDetail} from "../../types/IOfferDetail";
import {getOfferBuildingPolygonOptions} from "../constants/offer_building_polygon_properties";
import {IOfferBuilding} from "../types/IOfferBuilding";

interface IProps {
    area?: {
        center: {
            coordinates: [number, number];
        };
        polygon: {
            coordinates: number[][][];
        };
        region: number;
    };
    offer: IOfferDetail | IPropertyDetailOffer;
    property?: {
        id: number;
        for_sale: boolean;
        building?: number;
    };
    offerBuildings?: IOfferBuilding[];
}

export const OfferMapModalContent = (props: IProps) => {
    const [poiDistance, setPoiDistance] = useState<number>(POI_DISTANCE_DEFAULT_VALUE);

    const dispatch = useAppDispatch();
    const pendingSinglePoi = useAppSelector((state) => state.pendingSinglePoi.poi);
    const {markers: userMarkers, onSinglePoiChange} = useSinglePoiMarker(props.offer);

    useEffect(() => {
        if (pendingSinglePoi) {
            onSinglePoiChange(pendingSinglePoi);
            dispatch(clearPendingSinglePoi());
        }
    }, [pendingSinglePoi]);

    const {offerAdditionalPois, defaultPoiTypes, mapBottomSlot} = useMapNearbyOffersPois({
        baseOffer: {
            id: props.offer.id,
            type: props.offer.type,
            stats: {
                ranges_area_min: props.offer.stats?.ranges_area_min,
                ranges_area_max: props.offer.stats?.ranges_area_max,
                rooms: props.offer.stats?.rooms
            }
        },
        distance: poiDistance,
        showPropertyNumberOnMarker: !!props.property
    });

    const createOfferBuildingsPolygonList = () => {
        if (props.offerBuildings) {
            return props.offerBuildings.map(({geo_area, name, floors_count, id}) => ({
                coords: [geo_area.coordinates],
                options: getOfferBuildingPolygonOptions(id, props.property?.building),
                infoWindow: {
                    content: name
                },
                type: PolygonType.BLOCK,
                height: floors_count
            }));
        }
    };

    const onPoiClick = useCallback<OsmPoiClickHandler>(
        (poi, poiType, poiSubType) => {
            trackAmplitudeMapPoiClick({
                location: props.property ? "property_page" : "investment_page",
                poi,
                poiType,
                poiSubType,
                itemId: props.offer.id,
                propertyId: props.property?.id ?? null
            });
        },
        [props.offer.id, props.property?.id]
    );

    return (
        <div className={mapModalHolderStyle}>
            <OpenStreetMapsWithPoi
                offer={props.offer}
                viewType={props.property ? ViewType.PROPERTY : ViewType.OFFER}
                polygon={props.area && props.area.polygon}
                detailPolygons={createOfferBuildingsPolygonList()}
                region={props.area && props.area.region}
                disableInitiallyOpenedPoiId
                mapConfig={{fitBounds: true}}
                clusterMarkers
                customMarkers={userMarkers}
                customPoiMarkers={offerAdditionalPois}
                disablePoiSwitch={!getHasCountryPois(props.offer.region.country)}
                initialPoiTypes={defaultPoiTypes}
                mapBottomSlot={mapBottomSlot}
                className={mapCustomStylesStyle}
                onPoiClick={onPoiClick}
                drawPoiDistance
                onDistanceChange={setPoiDistance}
            />
        </div>
    );
};

const mapModalHolderStyle = css({
    flexGrow: 1,
    display: "flex",
    flexDirection: "row",
    pr: 0,
    position: "relative"
});

const mapCustomStylesStyle = css({
    "& .leaflet-div-icon": {
        backgroundColor: "transparent !important",
        border: "none !important"
    }
});
import {useCallback, useEffect, useState} from "react";
import {css} from "@panda/css";

import {OpenStreetMapsWithPoi} from "../../../maps/components/map_with_poi/OpenStreetMapsWithPoi";
import {POI_DISTANCE_DEFAULT_VALUE} from "../../../maps/constants/pois_defaults";
import {useMapNearbyOffersPois} from "../../../maps/hooks/use_map_nearby_offers_pois";
import {useSinglePoiMarker} from "../../../maps/hooks/use_single_poi_marker";
import {clearPendingSinglePoi} from "../../../maps/state/pending_single_poi_slice";
import {trackAmplitudeMapPoiClick} from "../../../maps/tracking/track_amplitude_poi_click";
import {PolygonType} from "../../../maps/types/PolygonType";
import {OsmPoiClickHandler} from "../../../maps/utils/create_get_osm_poi_marker";
import {getHasCountryPois} from "../../../maps/utils/get_has_country_pois";
import {IPropertyDetailOffer} from "../../../property/types/IPropertyDetailOffer";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {ViewType} from "../../../view_type/ViewType";
import {IOfferDetail} from "../../types/IOfferDetail";
import {getOfferBuildingPolygonOptions} from "../constants/offer_building_polygon_properties";
import {IOfferBuilding} from "../types/IOfferBuilding";

interface IProps {
    area?: {
        center: {
            coordinates: [number, number];
        };
        polygon: {
            coordinates: number[][][];
        };
        region: number;
    };
    offer: IOfferDetail | IPropertyDetailOffer;
    property?: {
        id: number;
        for_sale: boolean;
        building?: number;
    };
    offerBuildings?: IOfferBuilding[];
}

export const OfferMapModalContent = (props: IProps) => {
    const [poiDistance, setPoiDistance] = useState<number>(POI_DISTANCE_DEFAULT_VALUE);

    const dispatch = useAppDispatch();
    const pendingSinglePoi = useAppSelector((state) => state.pendingSinglePoi.poi);
    const {markers: userMarkers, onSinglePoiChange} = useSinglePoiMarker(props.offer);

    useEffect(() => {
        if (pendingSinglePoi) {
            onSinglePoiChange(pendingSinglePoi);
            dispatch(clearPendingSinglePoi());
        }
    }, [pendingSinglePoi]);

    const {offerAdditionalPois, defaultPoiTypes, mapBottomSlot} = useMapNearbyOffersPois({
        baseOffer: {
            id: props.offer.id,
            type: props.offer.type,
            stats: {
                ranges_area_min: props.offer.stats?.ranges_area_min,
                ranges_area_max: props.offer.stats?.ranges_area_max,
                rooms: props.offer.stats?.rooms
            }
        },
        distance: poiDistance,
        showPropertyNumberOnMarker: !!props.property
    });

    const createOfferBuildingsPolygonList = () => {
        if (props.offerBuildings) {
            return props.offerBuildings.map(({geo_area, name, floors_count, id}) => ({
                coords: [geo_area.coordinates],
                options: getOfferBuildingPolygonOptions(id, props.property?.building),
                infoWindow: {
                    content: name
                },
                type: PolygonType.BLOCK,
                height: floors_count
            }));
        }
    };

    const onPoiClick = useCallback<OsmPoiClickHandler>(
        (poi, poiType, poiSubType) => {
            trackAmplitudeMapPoiClick({
                location: props.property ? "property_page" : "investment_page",
                poi,
                poiType,
                poiSubType,
                itemId: props.offer.id,
                propertyId: props.property?.id ?? null
            });
        },
        [props.offer.id, props.property?.id]
    );

    return (
        <div className={mapModalHolderStyle}>
            <OpenStreetMapsWithPoi
                offer={props.offer}
                viewType={props.property ? ViewType.PROPERTY : ViewType.OFFER}
                polygon={props.area && props.area.polygon}
                detailPolygons={createOfferBuildingsPolygonList()}
                region={props.area && props.area.region}
                disableInitiallyOpenedPoiId
                mapConfig={{fitBounds: true}}
                clusterMarkers
                customMarkers={userMarkers}
                customPoiMarkers={offerAdditionalPois}
                disablePoiSwitch={!getHasCountryPois(props.offer.region.country)}
                initialPoiTypes={defaultPoiTypes}
                mapBottomSlot={mapBottomSlot}
                className={mapCustomStylesStyle}
                onPoiClick={onPoiClick}
                drawPoiDistance
                onDistanceChange={setPoiDistance}
            />
        </div>
    );
};

const mapModalHolderStyle = css({
    flexGrow: 1,
    display: "flex",
    flexDirection: "row",
    pr: 0,
    position: "relative"
});

const mapCustomStylesStyle = css({
    "& .leaflet-div-icon": {
        backgroundColor: "transparent !important",
        border: "none !important"
    }
});
